import { NATIVE_MINT } from "@solana/spl-token";
import { LAMPORTS_PER_SOL, VersionedTransaction } from "@solana/web3.js";

const jupiter = {
  namespaced: true,
  state: {},
  mutations: {},
  getters: {
    getQuoteData: () => async (payload) => {
      const { inputMint, outputMint, amount, slippage } = payload;
      return await (
        await fetch(
          `https://quote-api.jup.ag/v6/quote?inputMint=${inputMint}&outputMint=${outputMint}&amount=${amount}&slippageBps=${
            slippage * 100
          }`
        )
      ).json();
    },
  },
  actions: {
    async swapTransaction({ rootState }, payload) {
      const { sender, inputMint, outputMint, amount } = payload;
      const quoteResponse = await (
        await fetch(
          `https://quote-api.jup.ag/v6/quote?inputMint=${inputMint}&outputMint=${outputMint}&amount=${amount}&slippageBps=${
            rootState.solana.slippage * 100
          }`
        )
      ).json();
      const { swapTransaction } = await (
        await fetch("https://quote-api.jup.ag/v6/swap", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            quoteResponse,
            userPublicKey: sender.publicKey.toString(),
            wrapAndUnwrapSol: true,
            dynamicComputeUnitLimit: true,
            prioritizationFeeLamports:
              rootState.solana.priorityFee * LAMPORTS_PER_SOL,
          }),
        })
      ).json();

      const swapTransactionBuf = Buffer.from(swapTransaction, "base64");
      return VersionedTransaction.deserialize(swapTransactionBuf);
    },
    async buy({ rootState, dispatch, rootGetters }, payload) {
      const { wallet, amount } = payload;
      const sender = rootGetters["solana/getSender"](wallet.privateKey);
      const tx = await dispatch("swapTransaction", {
        sender,
        inputMint: NATIVE_MINT.toBase58(),
        outputMint: rootState.solana.mint.toBase58(),
        amount: (amount * LAMPORTS_PER_SOL).toFixed(0),
      });
      tx.sign([sender]);
      const signature = await rootState.solana.connection.sendTransaction(tx, {
        skipPreflight: true,
      });
      const txResult = await rootGetters["solana/getTxDetails"](signature);
      if (txResult) {
        return signature;
      }
      throw new Error("Transaction failed!");
    },
    async sell({ rootState, dispatch, rootGetters }, payload) {
      const { wallet, amount } = payload;
      const sender = rootGetters["solana/getSender"](wallet.privateKey);
      const tx = await dispatch("swapTransaction", {
        sender,
        inputMint: rootState.solana.mint.toBase58(),
        outputMint: NATIVE_MINT.toBase58(),
        amount: (
          amount * Math.pow(10, rootState.solana.metadata.decimals)
        ).toFixed(0),
      });
      tx.sign([sender]);
      const signature = await rootState.solana.connection.sendTransaction(tx, {
        skipPreflight: true,
      });
      const txResult = await rootGetters["solana/getTxDetails"](signature);
      if (txResult) {
        return signature;
      }
      throw new Error("Transaction failed!");
    },
  },
};

export default jupiter;
